export function sliderControl() {
    const slider = document.getElementById('rating-control');
    const ratingValue = document.getElementById('rating-value');
    const newReview = document.getElementById('new-review');
    slider.addEventListener('input', function () {
        ratingValue.innerText = this.value;
        const star = newReview.querySelector('.card__rating-start-inner');
        star.style.width = `${this.value * 1 * 20}%`
    })
}